import React, { useEffect, useRef } from 'react';
import { Box, Button, Circle } from '@chakra-ui/react';
import { useTheme } from '@chakra-ui/react';
import { useState } from 'react';
import { TransparentSpeechBubble } from '../../icons';
import { getIntroField } from '../../utils';
import { Store } from '../../store';
import { SubstitutableLabels } from '../../utils/labels';
import { OnlineIndicator } from './OnlineIndicator';

export const IntroChatButton = ({
  labels,
  onClick
}: {
  labels: SubstitutableLabels;
  onClick: () => void;
}) => {
  const [buttonDisabled, setButtonDisabled] = useState(
    Boolean(getIntroField(`introMessage-fa3fc71d-2ba4-46f6-a354-d42a4a04443e`))
  );
  const theme = useTheme();
  const introButtonRef = useRef<null | HTMLButtonElement>(null);
  const isActivatorOpen = Store.useState((s) => s.activatorVisible);

  useEffect(() => {
    if (introButtonRef && introButtonRef.current && !buttonDisabled && !isActivatorOpen) {
      setTimeout(() => introButtonRef?.current?.focus(), 200);
    }
  }, [introButtonRef, buttonDisabled, isActivatorOpen]);

  return (
    <Button
      variant="submit-cta"
      isDisabled={buttonDisabled}
      onClick={() => {
        onClick();
        setButtonDisabled(true);
      }}
      leftIcon={
        <TransparentSpeechBubble
          fill={`${theme?.colors?.scheme?.contentInversePrimary}33`}
          w="16px"
          h="16px"
        />
      }
      aria-label={`${labels.greetingDetail} Click here to ${labels.chatWithExpert}`}
      tabIndex={0}
      ref={introButtonRef}
      rightIcon={<OnlineIndicator />}
    >
      {labels.chatWithExpert}
    </Button>
  );
};
